import React from 'react';

import {Logger} from '@wix/bi-logger-pre';
import {
  BricksBiService,
  BricksFedopsService,
  BricksServicesProvider,
  BricksServicesProviderProps,
  useCreateServices,
} from '@wix/premium-bricks-services';

import {createServices} from './createServices';
import {ServicesContext} from './ServicesContext';

export interface Services {
  fedopsLoggerService: BricksFedopsService<{}, {}>;
  biLoggerService: BricksBiService<Logger>;
}

export interface ServicesProviderProps extends Omit<BricksServicesProviderProps, 'context'> {}

export const ServicesProvider = (props: ServicesProviderProps) => {
  const services = useCreateServices(() => props.services || createServices());

  return (
    <BricksServicesProvider
      services={services}
      context={ServicesContext}
      debugInstanceId={window.__DEBUG__ ? '__WhoisWeb__' : undefined}
    >
      {props.children}
    </BricksServicesProvider>
  );
};
